<template><section><h2>toast</h2>
<demo-block>
                  <div slot="source"><template>
  <weui-button type="default" @click="success()">成功提示</weui-button>
  <weui-button type="default" @click="warn(false)">失败提示</weui-button>
  <weui-button type="default" @click="warn(true)">长文案提示</weui-button>
  <weui-button type="default" @click="loading()">加载中提示</weui-button>
  <weui-button type="default" @click="info()">文字提示</weui-button>
</template>

</div>
                  
                  <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;weui-button type=&quot;default&quot; @click=&quot;success()&quot;&gt;成功提示&lt;/weui-button&gt;
  &lt;weui-button type=&quot;default&quot; @click=&quot;warn(false)&quot;&gt;失败提示&lt;/weui-button&gt;
  &lt;weui-button type=&quot;default&quot; @click=&quot;warn(true)&quot;&gt;长文案提示&lt;/weui-button&gt;
  &lt;weui-button type=&quot;default&quot; @click=&quot;loading()&quot;&gt;加载中提示&lt;/weui-button&gt;
  &lt;weui-button type=&quot;default&quot; @click=&quot;info()&quot;&gt;文字提示&lt;/weui-button&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    methods: {
      success: function() {
        this.$toast.success('已成功');
      },
      warn: function(more) {
        if(!more) {
          this.$toast.warn('获取连接失败');
        } else {
          this.$toast.warn('此处为长文案提示详情', { more: true });
        }
      },
      loading: function() {
        this.$toast.loading('加载中', { duration: 0 });
        setTimeout(() =&gt; {
          this.$toast.hide()
        }, 4000)
      },
      info: function() {
        this.$toast.info('文字提示', {
          callback: () =&gt; {
            this.$toast.info('执行callback');
          }
        });
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2>Event</h2>
<h3>$toast.success(text, config)</h3>
<h3>$toast.warn(text, config)</h3>
<h3>$toast.loading(text, config)</h3>
<h3>$toast.info(text, config)</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>text</td>
<td>提示内容</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>config</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>duration</td>
<td>显示时长后自动关闭（单位：ms），0 表示永久</td>
<td>number</td>
<td>—</td>
<td>2000</td>
</tr>
<tr>
<td>more</td>
<td>是否为长文本，适用于 <code v-pre>success</code> <code v-pre>warn</code> <code v-pre>loading</code></td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>callback</td>
<td>关闭后的回调</td>
<td>function()</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>$toast.hide()</h3>
<p>关闭提示</p>
</section></template>

<script>
  export default {
    methods: {
      success: function() {
        this.$toast.success('已成功');
      },
      warn: function(more) {
        if(!more) {
          this.$toast.warn('获取连接失败');
        } else {
          this.$toast.warn('此处为长文案提示详情', { more: true });
        }
      },
      loading: function() {
        this.$toast.loading('加载中', { duration: 0 });
        setTimeout(() => {
          this.$toast.hide()
        }, 4000)
      },
      info: function() {
        this.$toast.info('文字提示', {
          callback: () => {
            this.$toast.info('执行callback');
          }
        });
      }
    }
  }
</script>